import { Routes } from '@angular/router';
import { AccessDeniedComponent } from '@core/components/miscellaneous/access-denied.component';
import { authGuard } from '@core/guards/auth.guard';
import { mainGuard } from '@core/guards/main.guard';
import { BI_DASHBOARDS_ROUTES } from 'src/app/features/BI-dashboards/BI-dashboard.routes';
import { SETTINGS_ROUTES } from 'src/app/features/settings/settings.routes';
import { MainLayoutComponent } from './main-layout.component';
import { bIAccessGuard } from '@core/guards/bi-access.guard';

export const MAIN_ROUTES: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [authGuard, mainGuard, bIAccessGuard],
    children: [
      ...BI_DASHBOARDS_ROUTES,
      ...SETTINGS_ROUTES,
      {
        path: '',
        redirectTo: 'bi-settings',
        pathMatch: 'full',
      },
      {
        path: '403',
        component: AccessDeniedComponent,
      },
    ],
  },
];
